<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>
    <Header/>
    <Scroll/>

    <div class="hp_loginWrap">
      <h2 class="hp_loginTit">
        회원가입
        <p>회원이 되면 더욱 다양한 혜택을 누릴 수 있습니다.</p>
      </h2>
      <!-- <div style="margin:20px auto; text-align:center;">
        가입 시 1,000 포인트 적립
      </div> -->

      <button @click="navigateToJoin" class="hp_loginBtn">회원가입하기</button>
      <button @click="navigateToReservation" class="hp_loginBtn03">비회원 예약하기</button>

      <div class="hp_snsLoginBox">
        <div class="hp_snsLogin_tit">
          SNS 간편 로그인
        </div>
        <p class="hp_snsLogin_subTxt">
          SNS계정으로 쉽고 빠르게 로그인을 할 수 있습니다.
        </p>
        <ul class="hp_snsLogin_icon">
          <li>
            <a
                :href="kakaoLoginUrl"
              >
              <img src="../../../assets/images/icon/login_kakao.png" alt="카카오로그인">
              <p>카카오톡 로그인</p>
            </a>
          </li>
          <!-- <li>
            <a>
              <img src="../../../assets/images/icon/login_naver.png" alt="네이버로그인">
              <p>네이버 로그인</p>
            </a>
          </li> -->
        </ul>
      </div>

      <p class="hp_loginAlready">
        이미 회원이신가요?
        <a @click="navigateToLogin">로그인</a>
      </p>
    </div>
    <Footer/>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Scroll from '../Section/Scroll.vue'
import Spiner from '../Section/Spiner.vue'
import { ref } from 'vue'
import {
  removeWhitespace,
  validateEngNum,
  validatePassword
} from '../../ETC/Validation.vue'
import {
  base_homepage_url_export
} from '../../ETC/Axios.vue'

export default {
  name: 'ReservationLogin',
  components: {
    Header: Header,
    Footer: Footer,
    Scroll,
    Spiner
  },
  setup () {
    return {
      clientId: '09c5eb1e59461c0210d2029fa7e09651',
      redirectUri: `${base_homepage_url_export}KaKaoLogin`,
      formData: ref({
        customerLoginID: '',
        customerPassword: ''
      }),
      errorData: ref({
        customerLoginIDError: '',
        customerPasswordError: ''
      }),
      statusData: ref({
        customerLoginStatus: false,
        customerPasswordStatus: false,
        spinnerStatus: false
      })
    }
  },
  computed: {
    kakaoLoginUrl () {
      return `https://kauth.kakao.com/oauth/authorize?client_id=${this.clientId}&redirect_uri=${this.redirectUri}&response_type=code`
    }
  },
  watch: {
    'formData.customerLoginID': function (value) {
      this.formData.customerLoginID = removeWhitespace(value)
      if (removeWhitespace(value) === '') {
        this.errorData.customerLoginIDError = '아이디는 필수 입력입니다.'
        this.statusData.customerLoginStatus = false
      } else if (removeWhitespace(value).length < 5) {
        this.errorData.customerLoginIDError = '아이디는 최소 6자이상 입력해야 합니다.'
        this.statusData.customerLoginStatus = false
      } else if (validateEngNum(removeWhitespace(value))) {
        this.errorData.customerLoginIDError = ''
        this.statusData.customerLoginStatus = true
      } else {
        this.errorData.customerLoginIDError = '한글 및 특수문자는 입력할 수 없습니다.'
        this.statusData.customerLoginStatus = false
      }
    },
    'formData.customerPassword': function (value) {
      this.formData.customerPassword = removeWhitespace(value)
      if (removeWhitespace(value) === '') {
        this.errorData.customerPasswordError = '비밀번호는 필수 입력입니다.'
        this.statusData.customerPasswordStatus = false
      } else if (validatePassword(removeWhitespace(value))) {
        this.errorData.customerPasswordError = ''
        this.statusData.customerPasswordStatus = true
      } else {
        this.errorData.customerPasswordError = '최소 8자리 / 숫자, 특수문자 각 1회 이상을 입력해야 합니다.'
        this.statusData.customerPasswordStatus = false
      }
    }
  },
  methods: {
    navigateToJoin () {
      this.$router.push({path: '/Join', query: {reser_status: '1'}})
    },
    navigateToReservation () {
      this.$router.push({path: '/Reservation'})
    },
    navigateToLogin () {
      this.$router.push({path: '/Login', query: {reser_status: '1'}})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Reservation/ReservationLogin.vue